import React, { useState, useEffect } from 'react';
import { Cake, Save, Loader2, CheckCircle } from 'lucide-react';
import { auth } from '../config/firebase';
import { configuracaoService } from '../services/api';

const AniversarioTab = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  const [ativo, setAtivo] = useState(false);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    const carregarDados = async () => {
      const user = auth.currentUser;
      if (!user) return;
      try {
        const res = await configuracaoService.obterAniversario(user.uid);
        setAtivo(res.data.ativo);
        setMensagem(res.data.mensagem || '');
      } catch (error) {
        console.error('Erro ao carregar aniversário:', error);
      } finally {
        setLoading(false);
      }
    };
    carregarDados();
  }, []);

  const handleSalvar = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess(false);
    try {
      const uid = auth.currentUser.uid;
      await configuracaoService.salvarAniversario(uid, { ativo, mensagem });
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (error) {
      alert('Erro ao salvar configuração de aniversário.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-10">
        <Loader2 className="animate-spin text-[#1883FF]" size={24} />
      </div>
    );
  }

  return (
    <div className="animate-fade-in-up">
      <div className="flex items-center gap-3 mb-6 border-b border-purple-50 pb-4">
        <Cake size={18} className="text-[#1883FF]" />
        <div>
          <h3 className="text-sm font-black uppercase italic text-slate-900 m-0">Aniversário Automático</h3>
          <p className="text-[10px] font-semibold text-slate-500 m-0 mt-1">
            Manda uma mensagem de parabéns pelo WhatsApp sozinha no dia do aniversário do cliente.
          </p>
        </div>
      </div>

      <form onSubmit={handleSalvar} className="flex flex-col gap-5">
        <label className="flex items-center gap-2 text-xs font-black uppercase text-slate-700 cursor-pointer select-none">
          <input type="checkbox" checked={ativo} onChange={e => setAtivo(e.target.checked)} />
          Ativar mensagem automática de aniversário
        </label>

        <div className="flex flex-col gap-1.5 text-left">
          <label className="text-[10px] font-black uppercase text-slate-400 tracking-wider ml-1">Mensagem</label>
          <textarea
            className="w-full bg-[#F8F7FF] border border-purple-50 py-3 px-4 rounded-xl text-sm font-semibold text-slate-900 outline-none transition-all focus:bg-white focus:border-[#6D28D9] focus:ring-4 focus:ring-[#6D28D9]/10 min-h-[90px] resize-y font-sans"
            placeholder="Ex: Feliz aniversário, {nome}! 🎉 Desejamos um dia incrível!"
            value={mensagem} onChange={e => setMensagem(e.target.value)}
          />
          <p className="text-[10px] text-slate-400 font-semibold ml-1">Use <code>{'{nome}'}</code> para inserir o primeiro nome do cliente automaticamente.</p>
        </div>

        <button
          type="submit" disabled={saving}
          className={`w-full sm:w-auto self-start px-6 py-3.5 border-none rounded-2xl text-white font-black text-xs uppercase tracking-wider flex items-center justify-center gap-2.5 transition-all duration-400 cursor-pointer shadow-lg active:scale-98 disabled:opacity-60 disabled:cursor-not-allowed ${success ? 'bg-[#059669] shadow-emerald-600/20' : 'bg-gradient-to-r from-[#1883FF] to-[#6D28D9] shadow-[#6D28D9]/20 hover:opacity-90 hover:-translate-y-0.5'}`}
        >
          {saving ? <Loader2 className="animate-spin" size={16} /> : success ? <CheckCircle size={16} /> : <Save size={16} />}
          {saving ? 'Salvando...' : success ? 'Salvo!' : 'Salvar'}
        </button>
      </form>
    </div>
  );
};

export default AniversarioTab;
